var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mail-callback-wrapper"},[(_vm.requestData)?_c('div',[_c(_vm.callbackComponent,{tag:"component",attrs:{"token":_vm.token,"request-data":_vm.requestData},on:{"success":_vm.handleSuccess}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }